'use strict';

Page.Usp = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		this.initRecentSearches();
		this.trackSearch();
		this.loadSections();
		this.bindShowMore();
		this.bindComplexShowAll();
	},

	// complex tiles list 6 buildings; "Show All N Buildings" reveals the
	// rest — all rows are already in the DOM (the RPC returns the full
	// list), so this is a pure class toggle, no fetch
	bindComplexShowAll: function bindComplexShowAll() {
		document.addEventListener('click', function (e) {
			if (!e.target || typeof e.target.closest !== 'function') {
				return;
			}
			var btn = e.target.closest('[data-usp-complex-more]');
			if (!btn) {
				return;
			}
			var tile = btn.closest('.usp-building-complex');
			if (tile) {
				tile.querySelectorAll('.usp-complex-building._hidden').forEach(function (card) {
					card.classList.remove('_hidden');
				});
			}
			btn.parentNode.removeChild(btn);
		});
	},

	// GTM: one `search` event per executed search. Every entry point (header
	// pill, menu form, homepage hero, mobile form, recent-search chips) is a
	// GET to this page, so firing on load == firing on explicit submit, and
	// autocomplete keystrokes never reach here. The results count is not
	// known at this point — sections arrive by separate RPCs and the lower
	// ones only load on scroll — so `search_results` (pushSearchResults)
	// follows once the page has decided between results and no results.
	searchTerm: function searchTerm() {
		var q = '';
		try {
			q = new URLSearchParams(window.location.search).get('query') || '';
		} catch (e) {}
		return q.trim().toLowerCase();
	},

	// one id per executed search, shared by `search` and `search_results`
	// so the two events can be joined in GA4. UUID where the browser has
	// it, otherwise timestamp + random suffix — unique enough for a join
	// key, and never derived from the term (two people searching "lewis"
	// must get different ids)
	searchId: function searchId() {
		if (!this._searchId) {
			var id = '';
			try {
				if (window.crypto && typeof window.crypto.randomUUID === 'function') {
					id = window.crypto.randomUUID();
				}
			} catch (e) {}
			if (!id) {
				id = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
			}
			this._searchId = id;
		}
		return this._searchId;
	},

	pushDataLayer: function pushDataLayer(payload) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(payload);
	},

	trackSearch: function trackSearch() {
		var term = this.searchTerm();
		if (!term) {
			return; // empty landing (/nyc/search with no query) is not a search
		}
		this.pushDataLayer({
			event: 'search',
			search_id: this.searchId(),
			search_term: term,
			search_type: 'global',
			search_results_count: null
		});
	},

	// fired once per page: as soon as the first section renders content
	// (has_results = true), or when every section settled empty
	pushSearchResults: function pushSearchResults(hasResults) {
		var term = this.searchTerm();
		if (!term || this.searchResultsPushed) {
			return;
		}
		this.searchResultsPushed = true;
		this.pushDataLayer({
			event: 'search_results',
			search_id: this.searchId(),
			search_term: term,
			search_type: 'global',
			search_has_results: !!hasResults
		});
	},

	// compact "Recent searches" strip under the title: the current query is
	// recorded in localStorage and the previous ones rendered as chips. All
	// client-side — the shell stays cacheable and the server keeps no state.
	// DOM APIs only: localStorage content is as untrusted as the query it
	// came from.
	initRecentSearches: function initRecentSearches() {
		var KEY = 'crUspRecentSearches';
		var holder = document.querySelector('.usp-recent');
		var storage;
		try {
			storage = window.localStorage;
		} catch (e) {/* blocked (privacy mode) */}
		if (!holder || !storage) {
			return;
		}

		var list = [];
		try {
			list = JSON.parse(storage.getItem(KEY)) || [];
		} catch (e) {}
		if (!Array.isArray(list)) {
			list = [];
		}
		list = list.filter(function (x) {
			return typeof x === 'string' && x.length >= 3;
		});

		var query = holder.getAttribute('data-query') || '';
		var ql = query.toLowerCase();

		// chips show what the user searched BEFORE this query
		var shown = list.filter(function (x) {
			return x.toLowerCase() !== ql;
		}).slice(0, 5);

		if (query.length >= 3) {
			var next = [query].concat(list.filter(function (x) {
				return x.toLowerCase() !== ql;
			})).slice(0, 8);
			try {
				storage.setItem(KEY, JSON.stringify(next));
			} catch (e) {/* quota */}
		}

		if (!shown.length) {
			return;
		}

		var base = holder.getAttribute('data-url') || '';
		shown.forEach(function (q) {
			var a = document.createElement('a');
			a.className = 'usp-recent-item';
			a.href = base + '?query=' + encodeURIComponent(q);
			a.textContent = q;
			holder.appendChild(a);
		});
		holder.hidden = false;
	},

	// each section is served by its own RPC (CITY-5538); sections appear as
	// they arrive (no reserved space), a single "Searching…" line shows while
	// anything is in flight, and a no-results message covers the all-empty case
	loadSections: function loadSections() {
		var self = this;
		var sections = Array.prototype.slice.call(document.querySelectorAll('.usp-section[data-rpc]'));
		var searching = document.querySelector('.usp-searching');
		var noResults = document.querySelector('.usp-no-results');
		var pending = sections.length;
		var found = 0;

		if (!pending) {
			if (searching) searching.hidden = true;
			if (noResults) noResults.hidden = false;
			return;
		}

		var settle = function settle() {
			pending--;
			// hide the spinner as soon as there is something to read — waiting
			// for all 7 sections leaves it spinning under rendered results for
			// up to the full 20s timeout on a flaky connection
			if (found && searching) {
				searching.hidden = true;
			}
			if (found) {
				self.pushSearchResults(true);
			}
			if (pending > 0) {
				return;
			}
			if (searching) searching.hidden = true;
			if (!found && noResults) noResults.hidden = false;
			if (!found) {
				self.pushSearchResults(false);
			}
		};

		var fetchSection = function fetchSection(section) {
			if (section.hasAttribute('data-usp-loading')) {
				return;
			}
			section.setAttribute('data-usp-loading', '1');

			var url = section.getAttribute('data-rpc');
			// 20s guard: one hung RPC must not pin the global "Searching…"
			// spinner forever
			var controller = new AbortController();
			var timer = setTimeout(function () {
				controller.abort();
			}, 20000);

			fetch(url, { credentials: 'same-origin', signal: controller.signal }).then(function (response) {
				if (!response.ok) {
					throw new Error('HTTP ' + response.status);
				}
				return response.json();
			}).then(function (json) {
				clearTimeout(timer);
				var html = json && json.data && json.data.html || '';
				if (html) {
					found++;
					section.innerHTML = html;
					// the card chrome (page.less .usp-section._filled) must only
					// wrap sections that actually rendered — an empty div styled
					// as a card would be a blank white box with a shadow
					section.classList.add('_filled');
					self.initPhotoCyclers(section);
				}
				if (json && json.data && json.data.match) {
					self.fillMatchesFor(json.data.match);
				}
				settle();
			}).catch(function (err) {
				clearTimeout(timer);
				// a failed section renders nothing, but never silently:
				// log it and still settle the spinner
				if (window.console && console.error) {
					console.error('usp: section failed', url, err);
				}
				settle();
			});
		};

		// defer below-the-fold sections: 7 concurrent RPCs contend badly on
		// mobile networks. The first two load immediately; the rest wait for
		// an IntersectionObserver. Observing must NOT start before the first
		// sections render — the empty section divs all sit at zero height at
		// the top of the page, so an immediate observe would report every one
		// of them as visible and defer nothing. Once the leading sections have
		// settled the layout is meaningful: whatever still fits in (or near)
		// the viewport loads, anything pushed below waits for scroll. An empty
		// results page never grows, so everything stays "visible" and loads —
		// which is exactly what the no-results detection needs.
		var EAGER = 2;
		var deferred = sections.slice(EAGER);
		var eagerPending = Math.min(sections.length, EAGER);
		var observed = false;

		var observeRest = function observeRest() {
			if (observed || !deferred.length) {
				return;
			}
			observed = true;

			if (!('IntersectionObserver' in window)) {
				deferred.forEach(fetchSection);
				return;
			}
			var io = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						io.unobserve(entry.target);
						fetchSection(entry.target);
					}
				});
			}, { rootMargin: '600px 0px' });
			deferred.forEach(function (s) {
				io.observe(s);
			});
		};

		var settleBase = settle;
		settle = function settle() {
			settleBase();
			if (eagerPending > 0) {
				eagerPending--;
				if (eagerPending === 0) {
					observeRest();
				}
			}
		};

		sections.slice(0, EAGER).forEach(fetchSection);
		// safety net: if the eager RPCs hang, don't hold the rest hostage
		setTimeout(observeRest, 4000);
	},

	// "Matches for "<name>"" header line, rendered client-side from the hood
	// RPC's match payload — the server shell must not block TTFB on the fuzzy
	// matcher. The typed keyword is highlighted when it appears as a literal
	// substring of the matched name (same rule the old server-side render
	// applied). DOM APIs only — match.name is data, never markup.
	fillMatchesFor: function fillMatchesFor(match) {
		var holder = document.querySelector('.matches-for');
		if (!holder || !match || !match.name || holder.childNodes.length) {
			return;
		}

		var link = document.createElement('a');
		link.href = match.url || '#';

		var query = holder.getAttribute('data-query') || '';
		var pos = query ? match.name.toLowerCase().indexOf(query.toLowerCase()) : -1;
		if (pos >= 0) {
			link.appendChild(document.createTextNode(match.name.slice(0, pos)));
			var mark = document.createElement('mark');
			mark.textContent = match.name.slice(pos, pos + query.length);
			link.appendChild(mark);
			link.appendChild(document.createTextNode(match.name.slice(pos + query.length)));
		} else {
			link.textContent = match.name;
		}

		holder.appendChild(document.createTextNode('Matches for “'));
		holder.appendChild(link);
		holder.appendChild(document.createTextNode('”'));
		holder.hidden = false;
	},

	// teams without a team photo carry their members' portraits stacked in the
	// avatar; fade through them every 3s (same cadence as the sell-agents cards)
	initPhotoCyclers: function initPhotoCyclers(root) {
		// purely decorative motion — skip it entirely for users who asked for
		// less, which also saves the timers on mobile
		if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		Array.prototype.slice.call(root.querySelectorAll('.usp-agent-photo-cycle:not([data-cycling])')).forEach(function (holder) {
			holder.setAttribute('data-cycling', '1');

			var photos = Array.prototype.slice.call(holder.querySelectorAll('img'));
			var current = 0;

			var timer = setInterval(function () {
				// self-cleanup: stop the timer if the holder ever leaves the
				// document (e.g. its section gets re-rendered)
				if (!document.documentElement.contains(holder)) {
					clearInterval(timer);
					return;
				}
				// don't burn cycles (or phone battery) in a background tab
				if (document.hidden) {
					return;
				}
				photos[current].classList.remove('is-active');
				current = (current + 1) % photos.length;
				photos[current].classList.add('is-active');
			}, 3000);
		});
	},

	// "Show More Matches" (agents/articles blocks): each click fetches the
	// next page of rows from the same RPC and appends them into the block's
	// [data-usp-rows] container; the button (with its footer) goes away when
	// the server says there's nothing left
	bindShowMore: function bindShowMore() {
		var self = this;
		document.addEventListener('click', function (e) {
			// document-level listener: the target of a synthetic click isn't
			// necessarily an Element, and .closest() on one would throw for
			// every click on the page
			if (!e.target || typeof e.target.closest !== 'function') {
				return;
			}

			var btn = e.target.closest('.usp-more');
			if (!btn) {
				return;
			}
			e.preventDefault();

			// ignore clicks while a page is already loading — without this a
			// double-click fires two identical fetches and appends the rows twice
			if (btn.hasAttribute('data-busy')) {
				return;
			}
			btn.setAttribute('data-busy', '1');

			var page = parseInt(btn.getAttribute('data-page'), 10) + 1;
			// same 20s guard loadSections uses — without it a stalled request
			// leaves the button permanently disabled (data-busy sets
			// pointer-events:none)
			var controller = new AbortController();
			var timer = setTimeout(function () {
				controller.abort();
			}, 20000);

			fetch(btn.getAttribute('data-rpc') + '&page=' + page, { credentials: 'same-origin', signal: controller.signal }).then(function (response) {
				if (!response.ok) {
					throw new Error('HTTP ' + response.status);
				}
				return response.json();
			}).then(function (json) {
				clearTimeout(timer);
				var rows = btn.closest('.usp-section').querySelector('[data-usp-rows]');
				rows.insertAdjacentHTML('beforeend', json && json.data && json.data.html || '');
				self.initPhotoCyclers(rows);
				btn.setAttribute('data-page', page);
				btn.removeAttribute('data-busy');
				if (!json || !json.data || !json.data.has_more) {
					// the footer is the button's direct wrapper in every block
					var footer = btn.parentNode;
					footer.parentNode.removeChild(footer);
				}
			}).catch(function (err) {
				clearTimeout(timer);
				if (window.console && console.error) {
					console.error('usp: show more failed', err);
				}
				btn.removeAttribute('data-busy');
			});
		});
	}
});
//# sourceMappingURL=usp.js.map
